import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Plane"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.0275 11.0625L15 7.5V4.5C15 2.84315 13.6569 1.5 12 1.5C10.3431 1.5 9 2.84315 9 4.5V7.5L1.9725 11.0625C1.68696 11.1762 1.4997 11.4526 1.5 11.76V15.51C1.5 15.9242 1.83579 16.26 2.25 16.26C2.32395 16.2583 2.39725 16.2457 2.4675 16.2225L9 13.5V17.25L6.4125 18.54C6.15787 18.6683 5.99802 18.9299 6 19.215V21.75C6 22.1642 6.33579 22.5 6.75 22.5C6.81957 22.511 6.89043 22.511 6.96 22.5L12 21L17.04 22.5C17.1096 22.511 17.1804 22.511 17.25 22.5C17.6642 22.5 18 22.1642 18 21.75V19.215C18.002 18.9299 17.8421 18.6683 17.5875 18.54L15 17.25V13.5L21.5325 16.2075C21.6028 16.2307 21.676 16.2433 21.75 16.245C22.1642 16.245 22.5 15.9092 22.5 15.495V11.745C22.4942 11.4431 22.308 11.1742 22.0275 11.0625ZM21 14.3625L13.5 11.25V18.18L16.5 19.68V20.7525L12 19.44L7.5 20.7525V19.68L10.5 18.18V11.25L3 14.3625V12.225L10.5 8.4225V4.5C10.5 3.67157 11.1716 3 12 3C12.8284 3 13.5 3.67157 13.5 4.5V8.4225L21 12.225V14.3625Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Plane.vue"]]);
